import iskconYouthForum1 from "../../../assets/images/iskcon-youth-forum1.jpg";
import iskconYouthForum2 from "../../../assets/images/iskcon-youth-forum2.jpg";
import iskconYouthForum3 from "../../../assets/images/iskcon-youth-forum3.jpg";
import iskconYouthForum4 from "../../../assets/images/iskcon-youth-forum4.jpg";
import iskconYouthForum5 from "../../../assets/images/iskcon-youth-forum5.jpg";
import iskconYouthForum6 from "../../../assets/images/iskcon-youth-forum6.jpg";

export const iskconYouthForumImages = [
  {
    id: 1,
    image: iskconYouthForum1,
  },
  {
    id: 2,
    image: iskconYouthForum2,
  },
  {
    id: 3,
    image: iskconYouthForum3,
  },
  {
    id: 4,
    image: iskconYouthForum4,
  },
  {
    id: 5,
    image: iskconYouthForum5,
  },
  {
    id: 6,
    image: iskconYouthForum6,
  },
];

export const iskconYouthForum = [
  "The ISKCON Youth Forum in Vallabh Vidya Nagar is an active and vibrant group that provides a space for young people to come together and explore their spirituality in a fun and supportive environment. With a wide range of activities and programs on offer, the Youth Forum is an important part of the ISKCON community in Vallabh Vidya Nagar.",

  "One of the main focuses of the Youth Forum is to provide opportunities for young people to engage in devotional activities and deepen their spiritual practice. This includes regular kirtans, bhajans, and japa sessions, as well as workshops and classes on various aspects of bhakti yoga.",

  "In addition to spiritual activities, the Youth Forum also organizes a range of social and cultural events, including picnics, hikes, sports competitions, and festivals. These activities provide young people with a chance to connect with like-minded individuals and build friendships based on shared values and interests.",

  "The Youth Forum is also actively involved in community service projects, with a focus on supporting the less fortunate members of society. This includes organizing food distribution programs, providing educational support to underprivileged children, and offering counseling and support to those in need.",

  "The ISKCON Youth Forum in Vallabh Vidya Nagar is a dynamic and vibrant group that provides young people with a supportive and welcoming community in which to explore their spirituality and make a positive impact on the world around them. Whether you are looking to deepen your spiritual practice, make new friends, or get involved in community service, the Youth Forum offers something for everyone.",

  "This seva is spearheaded by H.G Adi Guru Das, for more details please contact on given details.",
];

export const contactDetails = [
  {
    id: 2,
    number: "+91 74051 60363",
  },
];

export const emailDetails = ["adigurudasa.lok@gmail.com"];
